'use strict';

var chunkC7C34JBA_js = require('./chunk-C7C34JBA.js');
var a = require('react');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var a__default = /*#__PURE__*/_interopDefault(a);

var s=({data:i,onClickHandler:r,lazyLoadImage:n})=>{let{title:d,data:t}=i||{};return a__default.default.createElement(a__default.default.Fragment,null,a__default.default.createElement(chunkC7C34JBA_js.f,null,d),a__default.default.createElement(chunkC7C34JBA_js.l,null,t.map(o=>a__default.default.createElement("li",{key:o.name},a__default.default.createElement("a",{onClick:()=>r(o.name),href:o.url},a__default.default.createElement("img",{loading:n?"lazy":"eager",src:o.image,alt:o.alt}))))))};

exports.a = s;
